// Angular
import { Component, OnInit } from '@angular/core';
// Models
import { Tournament } from './../../models/tournament';
// Services

import { ApiService } from './../../services/api';
import * as lodash from 'lodash';
import { OAuthService } from './../../services/o-auth';
import { Club } from './../../models/club'
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
  templateUrl: './notification.component.html'
})
export class NotificationComponent implements OnInit {
  public club: any;
  public notifications: Array<any>;
  constructor(private apiService: ApiService, private oAuthService: OAuthService, private fireDatabase: AngularFireDatabase, ) {
    this.club = this.oAuthService.getClub();


  }



  ngOnInit() {

    this.initData()
  }



  initData() {
    this.notifications = []
    this.apiService.set(`/user-notifications/${this.club.cid}/count`, null)
    this.apiService.object(`/user-notifications/${this.club.cid}`)
      .then(not => {
        console.log(not);
        lodash.forEach(not.notifications, (item, key) => {

          this.fireDatabase.object(`/users/${item.uid}`)
            .subscribe((user: any) => {
              // console.log(user);
              item.user_name = user.fullName;
              item.avatar = user.avatar_thumb;
            });
          switch (item.type) {
            case "0":
              item.text = " tagged you in a post"
              item.link = "/components/postDetail/" + this.club.cid + "/" + item.post
              break;
            case "1":
              item.text = " commented on your post"
              item.link = "/components/postDetail/" + this.club.cid + "/" + item.post
              break;
            case "2":
              item.text = "  like your post"
              item.link = "/components/postDetail/" + this.club.cid + "/" + item.post
              break;
            case "3":
              item.text = " started following you"
              item.link = "/components/followerDetail/" + item.uid
              break;
            case "4":
              item.text = ""
              break;
            case "5":
              item.text = "New post from "
              item.link = "/components/postDetail/" + this.club.cid + "/" + item.post
              break;
            case "6":
              item.text = ""
              break;
            case "7":
              item.text = ""
              break;
            case "8":
              item.text = " likes a post that you are tagged in"
              item.link = "/components/postDetail/" + this.club.cid + "/" + item.post
              break;
            case "9":
              item.text = " likes your post "
              item.link = "/components/postDetail/" + this.club.cid + "/" + item.post

              break;
            case "10":
              item.text = " Your trial will expired within " + item.day + " days "
              item.link = "/components/subscription"
              break;
            case "11":
              item.text = " Your trial is expired!"
              item.link = "/components/subscription"

              break;
            case "12":
              item.text = " Your Subscription plan will expired within " + item.day + " days "
              item.link = "/components/subscription"

              break;
            case "13":
              item.text = " Your Subscription plan is expired! "
              item.link = "/components/subscription"

              break;

          }
          this.notifications.push(item)

        })



      })

    console.log(this.notifications);

  }



}




